<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { AppTextarea } from '@shared/ui/fields'

import { useCustomerFields } from '../model/customer-fields.hook'

defineOptions({
  name: 'CustomerNotesInfo',
})

const {
  refNotes,
  setNotes,
} = useCustomerFields()
</script>

<template>
  <div class="customer-info-group">
    <AppText name="body1-medium">
      Note
    </AppText>
    <AppTextarea
      class="customer-notes"
      name="notes"
      placeholder="Type here..."
      :value="refNotes"
      @input="setNotes"
    />
  </div>
</template>

<style scoped lang="scss" src="./CustomerInfoGroup.scss" />
